var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 10.1111H24.5556C24.9386 10.1111 25.306 10.2633 25.5769 10.5342C25.8478 10.8051 26 11.1725 26 11.5556V28.8889C26 29.272 25.8478 29.6394 25.5769 29.9103C25.306 30.1812 24.9386 30.3333 24.5556 30.3333H1.44444C1.06135 30.3333 0.693954 30.1812 0.423068 29.9103C0.152182 29.6394 0 29.272 0 28.8889V11.5556C0 11.1725 0.152182 10.8051 0.423068 10.5342C0.693954 10.2633 1.06135 10.1111 1.44444 10.1111H4.33333V8.66667C4.33333 6.36812 5.24643 4.16372 6.87174 2.53841C8.49706 0.913093 10.7015 0 13 0C15.2985 0 17.5029 0.913093 19.1283 2.53841C20.7536 4.16372 21.6667 6.36812 21.6667 8.66667V10.1111ZM18.7778 10.1111V8.66667C18.7778 7.1343 18.1691 5.6647 17.0855 4.58116C16.002 3.49762 14.5324 2.88889 13 2.88889C11.4676 2.88889 9.99804 3.49762 8.91449 4.58116C7.83095 5.6647 7.22222 7.1343 7.22222 8.66667V10.1111H18.7778ZM11.5556 18.7778V21.6667H14.4444V18.7778H11.5556ZM5.77778 18.7778V21.6667H8.66667V18.7778H5.77778ZM17.3333 18.7778V21.6667H20.2222V18.7778H17.3333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.e9dd7c942b248ca1cdeb2fa7a20a6a11.svg";
export { ForwardRef as ReactComponent };